import { useState, useEffect } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { addMember } from "../../services/memberService";
import { getTrainers } from "../../services/trainerService";
import { addPayment } from "../../services/paymentService";
import { getPlans } from "../../services/membershipService";
import Webcam from "react-webcam";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getGymByUserId } from "../../services/gymService";

import { getMemberCount } from "../../services/memberService";
import { auth } from "../../firebase/config";
import { getWorkoutPlans } from "../../services/workoutPlanService";
import "./AddMember.css";
import { getDietPlans } from "../../services/dietPlanService";
import { generateAccessToken } from "../../utils/generateAccessToken";
import { generateMemberId } from "../../services/memberIdService";
// import { doc, setDoc } from "firebase/firestore";
// import { db } from "../../firebase/config";
import { storage } from "../../firebase/config";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

export default function AddMember() {
  const webcamRef = useRef(null);
  const [dietPlans, setDietPlans] = useState([]);
  const [gym, setGym] = useState(null);

  const [showCamera, setShowCamera] = useState(false);
  const navigate = useNavigate();
  const [facingMode, setFacingMode] = useState("user");

  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    membershipPlan: "",
    membershipPlanId: "",
    trainerName: "",
    workoutPlanId: "",
    dietPlanId: "",
    joinDate: "",
    status: "Active",
    photo: "",
    photoPath: "",
    photoBase64: "",

    imageSize: 0,
  });

  const [trainers, setTrainers] = useState([]);
  const [plans, setPlans] = useState([]);
  const [photo, setPhoto] = useState("");
  const [workoutPlans, setWorkoutPlans] = useState([]);

  useEffect(() => {
    loadGym();
    loadTrainers();
    loadPlans();
    loadWorkoutPlans();
    loadDietPlans();
  }, []);

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => resolve(reader.result);

      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  };

  const loadGym = async () => {
    try {
      const data = await getGymByUserId(auth.currentUser.uid);
      setGym(data);
    } catch (error) {
      console.error(error);
    }
  };
  const loadWorkoutPlans = async () => {
    try {
      const data = await getWorkoutPlans();

      setWorkoutPlans(data);
    } catch (error) {
      console.error(error);
    }
  };

  const loadDietPlans = async () => {
    try {
      const data = await getDietPlans();
      setDietPlans(data);
    } catch (error) {
      console.error(error);
    }
  };

  const loadTrainers = async () => {
    try {
      const data = await getTrainers();
      setTrainers(data);
    } catch (error) {
      console.error(error);
    }
  };

  const loadPlans = async () => {
    try {
      const data = await getPlans();
      setPlans(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const calculateExpiryDate = (joinDate, planName) => {
    if (!joinDate || !planName) return "";

    const selectedPlan = plans.find((plan) => plan.planName === planName);

    if (!selectedPlan) return "";

    const date = new Date(joinDate);

    date.setDate(date.getDate() + Number(selectedPlan.duration));

    return date.toISOString().split("T")[0];
  };

  const getPlanAmount = (planName) => {
    const selectedPlan = plans.find((plan) => plan.planName === planName);

    return selectedPlan ? Number(selectedPlan.price) : 0;
  };

  const handleSubmit = async () => {
    if (!formData.fullName.trim()) {
      alert("Please enter Full Name");
      return;
    }

    if (!formData.phone.trim()) {
      alert("Please enter Phone Number");
      return;
    }
    if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      alert("Please enter a valid 10-digit Phone Number");
      return;
    }

    if (!formData.email.trim()) {
      alert("Please enter Email");
      return;
    }
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.membershipPlan) {
      alert("Please select Membership Plan");
      return;
    }

    if (!formData.joinDate) {
      alert("Please select Join Date");
      return;
    }

    if (!formData.trainerName) {
      alert("Please select Trainer");
      return;
    }

    if (gym?.features?.aiWorkout && !formData.workoutPlanId) {
      alert("Please select Workout Plan");
      return;
    }

    if (gym?.features?.dietPlan && !formData.dietPlanId) {
      alert("Please select Diet Plan");
      return;
    }

    if (!formData.photo) {
      alert("Please upload Member Photo");
      return;
    }

    try {
      if (!formData.membershipPlan) {
        alert("Please select a membership plan");
        return;
      }

      // ==========================
      // Check Member Limit
      // ==========================
      const gym = await getGymByUserId(auth.currentUser.uid);

      const memberCount = await getMemberCount();

      const memberLimit = Number(gym?.features?.memberLimit || 0);

      console.log("Current Members:", memberCount);
      console.log("Member Limit:", memberLimit);

      if (memberCount >= memberLimit) {
        alert(
          `Member limit reached!\n\nYour ${gym.subscriptionPlan} plan allows only ${memberLimit} members.\n\nPlease upgrade your subscription to add more members.`,
        );
        return;
      }

      console.log("Current Members:", memberCount);
      console.log("Member Limit:", gym.features?.memberLimit);

      // ==========================
      // Continue Adding Member
      // ==========================

      // const expiryDate = calculateExpiryDate(
      //   formData.joinDate,
      //   formData.membershipPlan,
      // );

      // console.log("Photo before saving:", formData.photo);
      // const memberData = {
      //   ...formData,

      //   expiryDate,

      //   accessToken: generateAccessToken(),

      //   portalEnabled: true,

      //   createdAt: new Date().toISOString(),
      // };

      // ==========================
      // Generate Member ID
      // ==========================

      const memberId = await generateMemberId();
      console.log("NEW GENERATED MEMBER ID:", memberId);

      console.log("Generated Member ID:", memberId);

      const expiryDate = calculateExpiryDate(
        formData.joinDate,
        formData.membershipPlan,
      );

      console.log("Photo before saving:", formData.photo);

      // ==========================
      // Member Data
      // ==========================

      const memberData = {
        ...formData,

        // Generated unique Member ID
        memberId: memberId,

        expiryDate,

        accessToken: generateAccessToken(),

        portalEnabled: true,

        createdAt: new Date().toISOString(),
      };

      console.log("FINAL MEMBER DATA:", memberData);
      console.log("FINAL MEMBER ID:", memberData.memberId);

      await addMember(memberData);

      await addPayment({
        memberId: memberId,
        memberName: formData.fullName,
        phone: formData.phone,
        membershipPlan: formData.membershipPlan,
        amount: getPlanAmount(formData.membershipPlan),
        paymentDate: new Date().toISOString().split("T")[0],
        status: "Pending",
      });

      alert("Member Added Successfully");
      navigate("/members");

      setFormData({
        fullName: "",
        phone: "",
        email: "",
        membershipPlan: "",
        membershipPlanId: "",
        trainerName: "",
        workoutPlanId: "",
        dietPlanId: "",
        joinDate: "",
        status: "Active",

        photo: "",
        photoPath: "",
        photoBase64: "",

        imageSize: 0,
      });

      setPhoto("");
    } catch (error) {
      console.error(error);
      alert("Error Adding Member");
    }
  };

  const handlePhotoChange = async (e) => {
    const file = e.target.files[0];

    if (!file) return;
    const gym = await getGymByUserId(auth.currentUser.uid);

    const usedBytes = Number(gym.storageUsed || 0);
    const limitBytes = Number(gym.storageLimit || 0) * 1024 * 1024;

    if (usedBytes + file.size > limitBytes) {
      alert(
        `Storage limit exceeded.\n\nUsed: ${(usedBytes / 1024 / 1024).toFixed(2)} MB\nLimit: ${gym.storageLimit} MB\n\nPlease upgrade your subscription.`,
      );
      return;
    }

    // Maximum 1 MB
    const MAX_MEMBER_SIZE = 1 * 1024 * 1024;

    if (file.size > MAX_MEMBER_SIZE) {
      alert("Member photo size must be less than 1 MB.");
      return;
    }

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];

    if (!allowedTypes.includes(file.type)) {
      alert("Only PNG, JPG, JPEG and WEBP images are allowed.");
      return;
    }

    try {
      const photoPath = `memberPhotos/${auth.currentUser.uid}/${Date.now()}_${file.name}`;

      const storageRef = ref(storage, photoPath);
      await uploadBytes(storageRef, file);

      const downloadURL = await getDownloadURL(storageRef);

      const photoBase64 = await fileToBase64(file);

      setPhoto(downloadURL);

      setFormData((prev) => ({
        ...prev,
        photo: downloadURL,
        photoPath,
        photoBase64,
        imageSize: file.size,
      }));

      alert("Member photo uploaded successfully.");
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  const capturePhoto = async (e) => {
    const imageSrc = webcamRef.current.getScreenshot();

    if (!imageSrc) {
      alert("Failed to capture image.");
      return;
    }

    try {
      // Convert Base64 to Blob
      const response = await fetch(imageSrc);
      const blob = await response.blob();
      const gym = await getGymByUserId(auth.currentUser.uid);

      const usedBytes = Number(gym.storageUsed || 0);

      const limitBytes = Number(gym.storageLimit || 0) * 1024 * 1024;

      if (usedBytes + blob.size > limitBytes) {
        alert(
          `Storage limit exceeded.\n\nUsed: ${(usedBytes / 1024 / 1024).toFixed(2)} MB\nLimit: ${gym.storageLimit} MB\n\nPlease upgrade your subscription.`,
        );
        return;
      }

      // Maximum 1 MB
      const MAX_SIZE = 1 * 1024 * 1024;

      if (blob.size > MAX_SIZE) {
        alert("Captured photo must be less than 1 MB.");
        return;
      }

      const photoPath = `memberPhotos/${auth.currentUser.uid}/${Date.now()}_camera.jpg`;

      const storageRef = ref(storage, photoPath);

      await uploadBytes(storageRef, blob);

      const downloadURL = await getDownloadURL(storageRef);

      setPhoto(downloadURL);

      setFormData((prev) => ({
        ...prev,
        photo: downloadURL,
        photoPath,
        photoBase64: imageSrc,
        imageSize: blob.size,
      }));

      setShowCamera(false);

      alert("Photo captured and uploaded successfully.");
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  const switchCamera = () => {
    setFacingMode((prev) => (prev === "user" ? "environment" : "user"));
  };

  return (
    <DashboardLayout>
      <div className="member-form-card">
        <h2 className="form-title">Add New Member</h2>

        <div className="form-grid">
          <div className="form-group">
            <label>Full Name</label>

            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Phone Number</label>

            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Email</label>

            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Membership Plan</label>

            <select
              value={formData.membershipPlanId}
              onChange={(e) => {
                const selectedPlan = plans.find(
                  (plan) => plan.id === e.target.value,
                );

                setFormData({
                  ...formData,
                  membershipPlanId: selectedPlan.id,
                  membershipPlan: selectedPlan.planName,
                });
              }}
            >
              <option value="">Select Plan</option>

              {plans.map((plan) => (
                <option key={plan.id} value={plan.id}>
                  {plan.planName} - ₹{plan.price}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Trainer</label>

            <select
              name="trainerName"
              value={formData.trainerName}
              onChange={handleChange}
              required
            >
              <option value="">Select Trainer</option>

              {trainers.map((trainer) => (
                <option key={trainer.id} value={trainer.name}>
                  {trainer.name}
                </option>
              ))}
            </select>
          </div>

          {gym?.features?.aiWorkout && (
            <div className="form-group">
              <label>Workout Plan</label>

              <select
                name="workoutPlanId"
                value={formData.workoutPlanId}
                onChange={handleChange}
                required
              >
                <option value="">Select Workout Plan</option>

                {workoutPlans.map((plan) => (
                  <option key={plan.id} value={plan.id}>
                    {plan.planName}
                  </option>
                ))}
              </select>
            </div>
          )}

          {gym?.features?.dietPlan && (
            <div className="form-group">
              <label>Diet Plan</label>

              <select
                name="dietPlanId"
                value={formData.dietPlanId}
                onChange={handleChange}
                required
              >
                <option value="">Select Diet Plan</option>

                {dietPlans.map((plan) => (
                  <option key={plan.id} value={plan.id}>
                    {plan.planName}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group">
            <label>Join Date</label>

            <input
              type="date"
              name="joinDate"
              value={formData.joinDate}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Expiry Date</label>

            <input
              type="text"
              readOnly
              value={
                formData.joinDate && formData.membershipPlan
                  ? calculateExpiryDate(
                      formData.joinDate,
                      formData.membershipPlan,
                    )
                  : ""
              }
            />
          </div>

          <div className="form-group">
            <label>Status</label>

            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
              <option value="Expired">Expired</option>
            </select>
          </div>

          <div className="form-group">
            <label>Member Photo</label>

            <div className="photo-upload-options">
              {/* Upload From Device */}
              <div className="upload-box">
                <label className="upload-btn">
                  Upload From Device
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handlePhotoChange}
                    hidden
                  />
                </label>
              </div>

              {/* Open Camera */}
              <div className="upload-box">
                <button
                  type="button"
                  className="upload-btn camera-btn"
                  onClick={() => setShowCamera(true)}
                >
                  Capture From Camera
                </button>
              </div>
            </div>
          </div>

          {photo && (
            <div className="photo-preview">
              <img src={photo} alt="Member" />
            </div>
          )}
        </div>

        <button className="save-btn" onClick={handleSubmit}>
          Save Member
        </button>

        {showCamera && (
          <div className="camera-container">
            {/* <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              className="webcam-preview"
            /> */}

            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              className="webcam-preview"
              videoConstraints={{
                facingMode: facingMode,
              }}
            />

            <div className="camera-actions">
              <button
                type="button"
                className="switch-btn"
                onClick={switchCamera}
              >
                Switch Camera
              </button>
              <button
                type="button"
                className="capture-btn"
                onClick={capturePhoto}
              >
                Capture Photo
              </button>

              <button
                type="button"
                className="cancel-btn"
                onClick={() => setShowCamera(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
